import { render, staticRenderFns } from "./audience-cpm.vue?vue&type=template&id=f88715f0&scoped=true"
import script from "./audience-cpm.vue?vue&type=script&lang=js"
export * from "./audience-cpm.vue?vue&type=script&lang=js"
import style0 from "./audience-cpm.vue?vue&type=style&index=0&id=f88715f0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f88715f0",
  null
  
)

export default component.exports